module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point01-aac8c7218e719703522ff1dfec376c35.png";